<template>
  <div>
  <!-- banner图 -->
  <section class="banners">
    <!-- <div class="swiper-banner swiper-container swiper-no-swiping">
      <div class="carousel-body swiper-wrapper">
        <div v-for="(item, index) in bannerArr" :key="index" class="swiper-slide carousel-box">
          <div>
            <img :src="'storage/'+item.imgurl" :alt="item.title" draggable="false" />
          </div>
        </div>
      </div>
    </div> -->
        <img
        src="../assets/img/flow/kols_banner.png"
        alt="领先的数字娱乐内容供应商和服务商"
      />
  </section>
    <div class="fixed-div">
      <div class="main-div" @mouseover = "showSt = true">
        <img src="../assets/img/flow/fixed/float.png" alt="" @mouseout = "showSt = false">
      </div>
      <div class="content-wrap" :class="showSt ? 'showSt' : '' " @mouseover = "showSt = true" @mouseout = "showSt = false">
        <div class="par-wrap" @click="toContact">
          <img src="../assets/img/flow/fixed/phone_icon.png" alt="">
          <div class="par-desc">
            <h4>达人商务合作</h4>
            <p>联系邮件：</p>
            <p>zhangyuezhong@chinanola.com</p>
            <p>或留下信息我们联系您</p>
          </div>
        </div>
        <div class="weixin-wrap">
          <img src="../assets/img/flow/fixed/weixin.png" class="weixin" alt="">
          <div class="img-wrap">
            <img src="../assets/img/juxin-wchat.png" alt="">
          </div>
        </div>
      </div>
    </div>
  <div class="container">
    <section class="h1-wrap">
      <div class="title-wrap">
      <img src="../assets/img/flow/h4_icon1.png" alt="">
      </div>
      <div class="h1-content">
        <div class="img-wrap">
          <img src="../assets/img/flow/h1_icon1.png" alt="" srcset="">
        </div>
        <div class="img-wrap">
          <img src="../assets/img/flow/h1_icon2.png" alt="" srcset="">
        </div>
      </div>

    </section>

    <div class="h4-wrap">
      <section class="wrap">
        <h4>我们的服务</h4>
        <p>丰富资源，全力支持</p>
        <div class="swiper-sevice swiper-container">
          <div class="h4-content swiper-wrapper">
            <div class="item swiper-slide" :class="activeIndex == 1 ? 'active' : '' ">
              <div class="front">
                <div class="img-wrap">
                  <img src="../assets/img/flow/bus_icon1.png" alt="">
                </div>
                <div class="item-content">
                  <p>独家运营经验</p>
                  <p>百万账号运营手册</p>
                </div>
              </div>
            </div>
            <div class="item swiper-slide" :class="activeIndex == 2 ? 'active' : '' ">
              <div class="front">
                <div class="img-wrap">
                  <img src="../assets/img/flow/bus_icon2.png" alt="">
                </div>
                <div class="item-content">
                  <p>原创内容保护</p>
                  <p>对盗版内容即使提报处理</p>
                </div>
              </div>
            </div>
            <div class="item swiper-slide" :class="activeIndex == 3 ? 'active' : '' ">
              <div class="front">
                <div class="img-wrap">
                  <img src="../assets/img/flow/bus_icon3.png" alt="">
                </div>
                <div class="item-content">
                  <p>商业化资源助力</p>
                  <p>（拥有大量合作游戏商cp）</p>
                </div>
              </div>
            </div>
            <div class="item swiper-slide" :class="activeIndex == 4 ? 'active' : '' ">
              <div class="front">
                <div class="img-wrap">
                  <img src="../assets/img/flow/bus_icon4.png" alt="">
                </div>
                <div class="item-content">
                  <p>游戏短视频专业的培训分享会</p>
                  <p>（1-2次/月）</p>
                </div>
              </div>
            </div>
            <div class="item swiper-slide" :class="activeIndex == 5 ? 'active' : '' ">
              <div class="front">
                <div class="img-wrap">
                  <img src="../assets/img/flow/bus_icon5.png" alt="">
                </div>
                <div class="item-content">
                  <p>平台政策享受活动优先参与</p>
                </div>
              </div>
            </div>
            <div class="item swiper-slide" :class="activeIndex == 6 ? 'active' : '' ">
              <div class="front">
                <div class="img-wrap">
                  <img src="../assets/img/flow/bus_icon6.png" alt="">
                </div>
                <div class="item-content">
                  <p>账号诊断、限流问题排查</p>
                </div>
              </div>
            </div>
            <div class="item swiper-slide" :class="activeIndex == 7 ? 'active' : '' ">
              <div class="front">
                <div class="img-wrap">
                  <img src="../assets/img/flow/bus_icon7.png" alt="">
                </div>
                <div class="item-content">
                  <p>独家平台任务主力达人变现</p>
                </div>
              </div>
            </div>
          </div>
          <div class="mcn-scrollbar">
            <div class="swiper-scrollbar" style="transition-duration: 0ms">
              <div
                class="swiper-scrollbar-drag"
                style="
                  transform: translate3d(0px, 0px, 0px);
                  background: rgb(182, 182, 182);
                  width: 1rem;
                  transition-duration: 0ms;
                "
              ></div>
            </div>
          </div>
        </div>
      </section>
    </div>


    <div class="cont">
      <h4>推广案例</h4>
      <p>优秀的游戏爆款打造能力</p>
      <div class="h3-wrap">
        <div class="wrap">
          <div class="h3-content">
            <div class="carousel swiper-container">
              <div class="carousel-body swiper-wrapper">
                <div class="swiper-slide carousel-box">
                  <div>
                    <!-- <img src="../assets/img/flow/pre_img1.png" class="banner-img"/> -->
                    <div class="content-wrap">
                      <div class="content">
                        <div class="content-hd">
                          <div class="img-wrap">
                            <img src="../assets/img/flow/icon_mmy.png" alt="">
                          </div>
                          <div class="hd-right">
                            <h4>摸摸鱼</h4>
                            <div class="tips-wrap">
                              <span>休闲</span>
                              <span>手游</span>
                            </div>
                          </div>
                        </div>
                        <p>摸摸鱼app，一个真正汇集免费游戏的平台软件，并且摸摸鱼平台中的游戏，为大家去除了广告的烦恼，每天都有新游戏，全部不要钱不氪金，让你可以轻松在这里选择自己喜欢的休闲小游戏，尽情的打发时间，操作方便，内存小，运行速度快，使用便捷。</p>
                        <div class="content-ft">
                          <div class="item">
                            <p>抖音话题曝光</p>
                            <p class="bold-text">10亿+</p>
                          </div>
                          <div class="item">
                            <p>预估下载量</p>
                            <p class="bold-text">近百万</p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="swiper-slide carousel-box">
                  <div>
                    <!-- <img src="../assets/img/flow/pre_img2.png" class="banner-img"/> -->
                    <div class="content-wrap">
                      <div class="content">
                        <div class="content-hd">
                          <div class="img-wrap">
                            <img src="../assets/img/flow/icon_hhw.png" alt="">
                          </div>
                          <div class="hd-right">
                            <h4>航海王：热血航线</h4>
                            <div class="tips-wrap">
                              <span>角色扮演</span>
                              <span>3D</span>
                              <span>动作手游</span>
                            </div>
                          </div>
                        </div>
                        <p>《航海王：热血航线》是一款全新正版航海王3D动作手机游戏，玩家可以跟随原著主线一路重温剧情，招募原著伙伴，进行3D即时战斗。还可以自由探索高度还原的海域世界，挑战海兽，采集挖宝，触发各种趣味彩蛋随机事件，玩出自己的奇幻航海冒险之旅</p>
                        <div class="content-ft">
                          <div class="item">
                            <p>双周话题曝光</p>
                            <p class="bold-text">破亿</p>
                          </div>
                          <div class="item">
                            <p></p>
                            <p class="bold-text"></p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="swiper-slide carousel-box">
                  <div>
                    <!-- <img src="../assets/img/flow/pre_img3.png" class="banner-img"/> -->
                    <div class="content-wrap">
                      <div class="content">
                        <div class="content-hd">
                          <div class="img-wrap">
                            <img src="../assets/img/flow/icon_fcds.png" alt="">
                          </div>
                          <div class="hd-right">
                            <h4>翡翠大师</h4>
                            <div class="tips-wrap">
                              <span>模拟经营</span>
                              <span>休闲</span>
                              <span>手游</span>
                            </div>
                          </div>
                        </div>
                        <p>《翡翠大师》是一款模拟经营游戏，玩家将体验到富有风险的翡翠原石选石过程，通过切石，设计，抛光的流程获得精美的翡翠雕刻成品，让自己的翡翠珍宝展馆发展壮大，熠熠生辉；在得到成就感的同时收获相关的翡翠知识。</p>
                        <div class="content-ft">
                          <div class="item">
                            <p>抖音话题曝光</p>
                            <p class="bold-text">亿级曝光</p>
                          </div>
                          <div class="item">
                            <p>预估下载量</p>
                            <p class="bold-text">近百万</p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="swiper-slide carousel-box">
                  <div>
                    <!-- <img src="../assets/img/flow/pre_img4.png" class="banner-img"/> -->
                    <div class="content-wrap">
                      <div class="content">
                        <div class="content-hd">
                          <div class="img-wrap">
                            <img src="../assets/img/flow/icon_bt.png" alt="">
                          </div>
                          <div class="hd-right">
                            <h4>比特大爆炸</h4>
                            <div class="tips-wrap">
                              <span>射击</span>
                              <span>像素</span>
                              <span>roguelike</span>
                              <span>手游</span>
                            </div>
                          </div>
                        </div>
                        <p>《比特大爆炸》是一款画风Q萌的飞行射击手游，游戏由3D像素构筑方块世界，拥有多种创意BOSS，战创新融合社交与roguelike元素，让玩家在花式弹幕的趣味战斗中，感受好友互撩恶搞的魅力。在游戏中，玩家需要磨练自身技巧，收获更多资源，强化自身最终打通关卡。</p>
                        <div class="content-ft">
                          <div class="item">
                            <p>单周话题</p>
                            <p class="bold-text">破百万曝光</p>
                          </div>
                          <div class="item">
                            <p>高转化下载量用户万</p>
                            <p class="bold-text">数万</p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="swiper-slide carousel-box">
                  <div>
                    <!-- <img src="../assets/img/flow/pre_img5.png" class="banner-img"/> -->
                    <div class="content-wrap">
                      <div class="content">
                        <div class="content-hd">
                          <div class="img-wrap">
                            <img src="../assets/img/flow/icon_wn.png" alt="">
                          </div>
                          <div class="hd-right">
                            <h4>最强蜗牛</h4>
                            <div class="tips-wrap">
                              <span>冒险</span>
                              <span>放置</span>
                              <span>养成</span>
                              <span>手游</span>
                            </div>
                          </div>
                        </div>
                        <p>一款拥有放置元素的收集养成游戏，也是披着游戏外衣的大型情景喜剧，玩家将扮演一只弱小的蜗牛，通过自身努力最终超越包括人类在内的所有种族，成为最强生物的故事。</p>
                        <div class="content-ft">
                          <div class="item">
                            <p>单周话题</p>
                            <p class="bold-text">破百万曝光</p>
                          </div>
                          <div class="item">
                            <p>下载量</p>
                            <p class="bold-text">七日破万</p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="swiper-slide carousel-box">
                  <div>
                    <!-- <img src="../assets/img/flow/pre_img6.png" class="banner-img"/> -->
                    <div class="content-wrap">
                      <div class="content">
                        <div class="content-hd">
                          <div class="img-wrap">
                            <img src="../assets/img/flow/icon_zqdmx.png" alt="">
                          </div>
                          <div class="hd-right">
                            <h4>最强大冒险2</h4>
                            <div class="tips-wrap">
                              <span>休闲</span>
                              <span>手游</span>
                            </div>
                          </div>
                        </div>
                        <p>最强大冒险2是一款休闲类闯关游戏。玩家需要控制三个不同大小的小绵羊做出不同的配合来进行闯关。并且利用各种特殊的技能和地形来跨越所有的障碍，克服路上的重重难关，最终抵达目的地
                          标签：休闲、闯关、益智
                          单月话题曝光超1亿</p>
                        <div class="content-ft">
                          <div class="item">
                            <p>抖音话题曝光</p>
                            <p class="bold-text">10亿+</p>
                          </div>
                          <div class="item">
                            <p>预估下载量</p>
                            <p class="bold-text">近百万</p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 领域矩阵，丰富的KOL资源 -->
    <section class="kols-wrap">
      <div class="title-wrap">
        <img src="../assets/img/flow/h4_icon2.png" alt="">
        </div>
      <div class="content-wrap">
        <div class="item-wrap">
          <div class="item" v-for='(item,index) in kols' :key='index'>
            <div v-if="index < 8 || moreShow">
              <div class="bg-wrap">
                <img :src="item.icon" class="kols-img" alt="">
                <div class="power">
                  <span>{{item.pow}}</span>
                </div>
              </div>
              <div class="img-wrap">
                <img src="../assets/img/flow/kols_bg.png" alt="">
              </div>
              <div class="kols-title">{{item.nickname}}</div>
            </div>

          </div>
          <div class="more" v-show="!moreShow" @click="moreShow = true">
            <span>查看更多</span>
          </div>
        </div>
      </div>
    </section>


    <section class="h2-wrap">
      <h4 style="margin-bottom:0px">合作伙伴</h4>
      <p>cooperative partner</p>
      <div class="h2-content">
        <div class="img-wrap">
          <img src="../assets/img/flow/par_bg.gif" alt="">
        </div>
      </div>
    </section>

  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    kols: [{
      icon: require("../assets/img/flow/kols/kols1.png"),
      nickname: "陈泥玛评测",
      pow:'537.8w'
    },{
      icon: require("../assets/img/flow/kols/kols2.png"),
      nickname: "小吴叔",
      pow:'223.9w'
    },{
      icon: require("../assets/img/flow/kols/kols3.png"),
      nickname: "白菜君",
      pow:'171.8w'
    },{
      icon: require("../assets/img/flow/kols/kols4.png"),
      nickname: "茶茶冲啊",
      pow:'53w'
    },{
      icon: require("../assets/img/flow/kols/kols5.png"),
      nickname: "灭霸游戏解说",
      pow:'82.1w'
    },{
      icon: require("../assets/img/flow/kols/kols6.png"),
      nickname: "凉凉小师姐",
      pow:'77.7w'
    },{
      icon: require("../assets/img/flow/kols/kols7.png"),
      nickname: "村服小兵",
      pow:'44.5w'
    },{
      icon: require("../assets/img/flow/kols/kols8.png"),
      nickname: "大号柒的无力",
      pow:'39.9w'
    },{
      icon: require("../assets/img/flow/kols/kols9.png"),
      nickname: "妞妞长大了",
      pow:'32.3w'
    },{
      icon: require("../assets/img/flow/kols/kols10.png"),
      nickname: "叫我官人",
      pow:'58.7w'
    },{
      icon: require("../assets/img/flow/kols/kols11.png"),
      nickname: "沐芝会",
      pow:'56.1w'
    },{
      icon: require("../assets/img/flow/kols/kols12.png"),
      nickname: "童话乐园",
      pow:'51.8w'
    },{
      icon: require("../assets/img/flow/kols/kols13.png"),
      nickname: "小精灵",
      pow:'79.7w'
    },{
      icon: require("../assets/img/flow/kols/kols14.png"),
      nickname: "疯阳游戏解说",
      pow:'72.8w'
    },{
      icon: require("../assets/img/flow/kols/kols15.png"),
      nickname: "繁星满天灰",
      pow:'101.4w'
    },{
      icon: require("../assets/img/flow/kols/kols16.png"),
      nickname: "一头帅雷",
      pow:'102.1w'
    },{
      icon: require("../assets/img/flow/kols/kols17.png"),
      nickname: "小小舞测试员",
      pow:'59.6w'
    },{
      icon: require("../assets/img/flow/kols/kols18.png"),
      nickname: "飞",
      pow:'58.4w'
    },{
      icon: require("../assets/img/flow/kols/kols19.png"),
      nickname: "抖游时间",
      pow:'92w'
    },{
      icon: require("../assets/img/flow/kols/kols20.jpg"),
      nickname: "玩乐动漫",
      pow:'94.8w'
    },{
      icon: require("../assets/img/flow/kols/kols21.jpg"),
      nickname: "三年动画师",
      pow:'52.2w'
    }],
    partners:[{
      icon: require("../assets/img/flow/par/partner_1.png"),
      nickname: "ohayoo",
      domain: "休闲手游/小游戏"
    },{
      icon: require("../assets/img/flow/par/partner_2.png"),
      nickname: "朝夕光年",
      domain: "休闲手游/小游戏"
    },{
      icon: require("../assets/img/flow/par/partner_3.png"),
      nickname: "咪佰",
      domain: "休闲手游/小游戏"
    },{
      icon: require("../assets/img/flow/par/partner_4.png"),
      nickname: "腾讯",
      domain: "休闲手游/小游戏"
    },{
      icon: require("../assets/img/flow/par/partner_5.png"),
      nickname: "青瓷游戏",
      domain: "休闲手游/小游戏"
    },{
      icon: require("../assets/img/flow/par/partner_6.png"),
      nickname: "完美世界",
      domain: "休闲手游/小游戏"
    },{
      icon: require("../assets/img/flow/par/partner_7.png"),
      nickname: "雷霆游戏",
      domain: "休闲手游/小游戏"
    },{
      icon: require("../assets/img/flow/par/partner_8.png"),
      nickname: "豪腾",
      domain: "休闲手游/小游戏"
    },{
      icon: require("../assets/img/flow/par/partner_9.png"),
      nickname: "米哈游",
      domain: "休闲手游/小游戏"
    },{
      icon: require("../assets/img/flow/par/partner_10.png"),
      nickname: "卡日曲",
      domain: "休闲手游/小游戏"
    }],
    pages:"3",
    showTop: false,
    bannerArr:null,
    isHover:0,
    activeIndex:1,
    showSt:false,
    moreShow:false
    };
  },
  created: function () {
    let that = this;
    // this.$ajax
    //   .post("/banners/" + this.pages)
    //   .then(function (res) {
    //     that.bannerUrl = res.banners[0].imgurl;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  },
  mounted(){
    var swiper2 = new Swiper('.swiper-banner', {
      autoplay: 5000,
      autoplayDisableOnInteraction : false,
      slidesPerView : 1,
      slidesPerGroup : 1,
      observer:true,  //修改swiper自己或子元素时，自动初始化swiper
      observeParents:true,
    });
    var swiper3 = new Swiper('.carousel', {
      autoplay: 5000,
      autoplayDisableOnInteraction : false,
      spaceBetween:20,
      slidesPerView : 1,
      slidesPerGroup : 1,
      observer:true,  //修改swiper自己或子元素时，自动初始化swiper
      observeParents:true,
    });
    var swiper4 = new Swiper('.swiper-sevice', {
      autoplay: 5000,
      autoplayDisableOnInteraction : false,
      spaceBetween:0,
      slidesPerView: 1,
      scrollbar: ".swiper-scrollbar",
      scrollbarHide: false,
      scrollbarDraggable: true,
      scrollbarSnapOnRelease: true,
      watchSlidesProgress: true,
      centeredSlides: true,
    });

  },
  methods: {
    toContact(){
      this.$router.push("/contact");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/global";
@import "../assets/css/function";
@import "../assets/css/index";
@import "../assets/css/fixed";



// 内容容器
.container {
  padding: 0;

  section{
    margin: 5rem auto 0;
    > h4 {
      letter-spacing: 4px;
      color: #535353;
      font-weight: 700;
      line-height: 1em;
      text-align: center;
      margin-bottom: 10px;
    }
    > p {
      letter-spacing: 1px;
      line-height: 1.6em;
      color: #535353;
      text-align: center;
    }



  }

}
.h2-wrap{
  margin-top: 3rem !important;
}
.h1-wrap,.kols-wrap{
  padding: 0 15px;
  .title-wrap{
    width: 80%;
    margin: 0 auto 1rem;
  }
  .more {
    position: relative;
    padding: 1rem 0;
    text-align: center;
    color: #999;
   margin: 0 auto;
  }
}
.h1-wrap{
  padding: 0 15px;
  .title-wrap{
    width: 80%;
    margin: 0 auto 1rem;
  }
    .h1-content{
      width: 100%;
      .img-wrap{
        margin-bottom: 1rem;
        position: relative;
        z-index: 6;
        box-shadow: 2px 3px 5px rgba(0,0,0,0.3);
        border-radius: 15px;
      }
    }
}





//领域矩阵，丰富的KOL资源
.kols-wrap{
  .content-wrap{
    .item-wrap{
      display: flex;
      flex-wrap: wrap;
      .item{
        position: relative;
        max-width: 25%;
        margin-top: 3%;
        height: 140px;
        .bg-wrap{
          width: 60%;
          border-radius: 50%;
          position: absolute;
          left: 20%;
          top: 3%;
          z-index: 6;
          overflow: hidden;
          &:hover{
            transform: scale(1.2);
            & + div{
              animation: bg_rotate 5s linear infinite;
              -webkit-animation:  bg_rotate 5s linear infinite;
            }
            & > .power{
              bottom: -30px;
            }
            & ~ .kols-title{
              -webkit-text-stroke: 0;
              color: #C1AFFE;
              white-space: normal;
            }
          }
        }
        .img-wrap{
          border-radius: 50%;
          width: 70%;
          margin: 0 auto;
          overflow: hidden;
        }
        .power{
          background-color: #D1C3FE;
          position: absolute;
          bottom: -51px;
          left: 0;
          width: 100%;
          display: flex;
          justify-content: center;
          border-radius: 50%;
          height: 50px;
          padding-top: 7px;
          transition: all 0.5s ease-in-out;
          >span{
            color: #535353;
            font-size: .6rem;
            font-family: 'youshe';
          }
        }
        .kols-title{
          -webkit-text-stroke: 1px #C1AFFE;
          font-family: "youshe";
          text-align: center;
          color: #fff;
          position: relative;
          top:20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
@keyframes bg_rotate {
  from{
    transform: rotate(0deg) scale(1.2);
  }
  to{
    transform: rotate(360deg) scale(1.2);
  }
}
@-webkit-keyframes bg_rotate {
  from{
    transform: rotate(0deg) scale(1.2);
  }
  to{
    transform: rotate(360deg) scale(1.2);
  }
}
.cont{
  margin-top: 3rem;
  > h4 {
    letter-spacing: 2px;
    color: #535353;
    font-weight: 700;
    line-height: 1em;
    text-align: center;
    margin-bottom: 10px;

  }
  > p {
    letter-spacing: 1px;
    font-size: px2rem(16);
    line-height: 1.6em;
    color: #535353;
    text-align: center;
    &:nth-last-of-type(1) {
      margin-bottom: 1rem;
    }
  }
}

.h2-wrap{
  .h2-content{
    position: relative;

  }
}
.h3-wrap{
  width: 100%;
  background-image: url("../assets/img/flow/h3_bg.png");
  background-size: 100%;
  margin-bottom: 2rem;
  .h3-content{
    display: flex;
    justify-content: space-between;
    .swiper-slide{
      >div{
        display: flex;
        position: relative;
        margin: 2rem;
        >img{
          width:100px;
          position: absolute;
          top: 20%;
          left: -25px;
          z-index: 66;
        }
        .content-wrap{
          position: relative;
          box-shadow: 5px 5px 10px rgba(0,0,0,.1);
          height: 310px;

          background: #fff;
          padding: 0 1rem;
          border-radius: 1rem;
          //
          .content{
            position: relative;
            padding: 1rem 0px;
            width: 95%;
            height: 100%;
            >p{
              color: #999;
            }
            .content-ft{
              position: absolute;
              bottom: 3.5rem;
              display: flex;
              justify-content: space-between;
              left: 0;
              right: 0;
              p{
                color: #535353;
                letter-spacing: 1px;
              }
              .bold-text{
                font-weight: bolder;
                font-size: 1.2rem;
              }
            }
          }

          .content-hd{
            display: flex;
            padding-bottom: 1rem;
            >.img-wrap{
              img{
                width: 60px;
                height: 60px;
              }
            }
            .hd-right{
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              padding-left: .5rem;
              h4{
                font-size: 1.2rem;
              }
              .tips-wrap{
                display: flex;
                justify-content: flex-start;
                span{
                  display: block;
                  font-size: .6rem;
                  background: #E1E1E1;
                  border-radius: 5px;
                  margin-right: .5rem;
                  padding: .2rem .3rem;
                }
              }

            }
          }
        }
      }
    }
  }
}

.mcn-scrollbar {
  margin: 20px auto;
  width: 220px;
  height: .6rem;
  .swiper-scrollbar {
    width: 100%;
    height: 100%;
    background: #6768C5;
    .swiper-scrollbar-drag{
      width: 20px !important;
      background:#fff !important;
    }
  }
}
.h4-wrap{
  .front,.back{
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 20px;
  }
  .h4-content{
    .item{
      // width: 50% !important;
      margin: 1rem 0;
      position: relative;
      transition:0.6s;
      transform-style:preserve-3d;
      .item-content{
        p{
          font-size: px2rem(14);
          line-height: 20px;
          text-align: center;
        }
      }
      .img-wrap{
        width: 50%;
        margin: 0 auto;
      }
      .front{
        width: 250px;
        height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin: 0 auto;
        padding:1rem;
        background: #fff;
        box-shadow: 0px 5px 7px rgba(0,0,0,.2);
        border: 1px solid rgb(245,245,245);
      }
      .back{
        background: #6767C5;
      }
    }
  }
}





</style>



// WEBPACK FOOTER //
// src/page/kols.vue